import {
  Prompt,
  PromptParameter,
  IRephraseState,
  TemplateParameters
} from '..'
  
  export interface IRephraseMutations {

    /**
     * Sets the prompts.
     * @param state Current state to update.
     */
    SET_PROMPTS(state: IRephraseState, prompts: Prompt[]): void

    /**
     * Sets the prompt parameters.
     * @param state Current state to update.
     */
    SET_PROMPT_PARAMETERS(state: IRephraseState, promptParameters: PromptParameter[]): void

    /**
     * Sets the prompt parameters.
     * @param state Current state to update.
     */
    SET_TEMPLATE_PARAMETERS(state: IRephraseState, templateParameters: TemplateParameters[]): void

    /**
     * Sets the langs.
     * @param state Current state to update.
     */
    SET_LANGS(state: IRephraseState, langs: string[]): void

    /**
     * Sets the current modified prompt.
     * @param state Current state to update.
     */
    UPDATE_PROMPT_PARAMETERS(state: IRephraseState, promptParameters: PromptParameter): void

    /**
     * Sets the current modified prompt.
     * @param state Current state to update.
     */
    SET_CURRENT_PROMPT_ID(state: IRephraseState, prompt: string): void
  }
  
  export const RephraseMutations: IRephraseMutations = {

    SET_PROMPTS: (state: IRephraseState, prompts: Prompt[]) => {
      state.prompts = prompts
    },
  
    SET_PROMPT_PARAMETERS: (state: IRephraseState, promptParameters: PromptParameter[]) => {
      state.promptParameters = promptParameters
    },

    SET_TEMPLATE_PARAMETERS: (state: IRephraseState, templateParameters: TemplateParameters[]) => {
      state.templateParameters = templateParameters
    },

    SET_LANGS: (state: IRephraseState, langs: string[]) => {
      state.langs = langs
    },

    UPDATE_PROMPT_PARAMETERS: (state: IRephraseState, promptParameter: any) => {
      if(state.promptParameters.length === 0) {
        state.promptParameters.push(promptParameter)
      }else{
        if(promptParameter.id){
          if(state.promptParameters.find((param: any) => param.id === promptParameter.id)){
            state.promptParameters = state.promptParameters.map((param: any) => {
              if (param.id === promptParameter.id) {
                return promptParameter;
              }
              return param;
            })
          }else{
            state.promptParameters.push(promptParameter)
          }
        }else{
          let exists = false
          state.promptParameters = state.promptParameters.map((param: any) => {
            if (!param.id && param.name === promptParameter.name && param.promptId === promptParameter.promptId && param.lang === promptParameter.lang) {
              exists = true;
              return promptParameter;
            }
            return param;
          })
          if (!exists) {
            state.promptParameters.push(promptParameter)
          }
        }
      }
    },

    SET_CURRENT_PROMPT_ID: (state: IRephraseState, prompt: string) => {
      state.currentPromptId = prompt
    }
  }
  